export const QUIZ_QUESTION_COUNT = 10;

function fisherYatesShuffle(array) {
  const shuffled = [...array];
  for (let i = shuffled.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
}

export function pickRandomQuestions(pool, count = QUIZ_QUESTION_COUNT) {
  const mcqs = pool.filter((q) => (q.type || "mcq") !== "text");
  const shuffled = fisherYatesShuffle(mcqs);
  return shuffled.slice(0, Math.min(count, shuffled.length));
}

export function formatTimeTaken(seconds) {
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${String(mins).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
}
